<script setup lang="ts">

const props = defineProps({
	isOpen: {
		type: Boolean,
		default: false,
	},
	status: {
		type: Number,
		required: true,
	},
});

defineEmits<{
	(e: 'onClose'): void
	(e: 'onAddCalendar'): void
	(e: 'onOpenTicketDetail'): void
}>();

const profileStore = useProfileStore();

const headerText = computed(() => {
	switch (props.status) {
		case CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_SUCCESS:
			return 'Thank you for your order!';
		case CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_FAILED:
			return 'Payment failed';
		case CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_SOMETHING_WENT_WRONG:
			return 'Something went wrong';
		default:
			return '';
	}
});

const isShowSuccessIcon = computed(() => {
	return props.status === CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_SUCCESS;
});

</script>
<template>
  <BaseSideDrawer
    :is-open="isOpen"
    @on-close="$emit('onClose')"
  >
    <template #content>
      <div
        class="payment-status"
      >
        <CheckCircleIcon
          v-if="isShowSuccessIcon"
          class="icon-header-confirm-dlg icon-success --lg"
          width="60"
          height="60"
          :color="ICON_COLOR.SUCCESS"
        />
        <AlertCircleIcon
          v-else
          class="icon-header-confirm-dlg icon-error --lg"
          width="60"
          height="60"
          stroke-width="1"
          :color="ICON_COLOR.ERROR"
        />
        <div>
          <h1 class="text-header text-lg text-semibold">
            {{ headerText }}
          </h1>
          <p class="text-md text-regular">
            <template v-if="status === CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_SUCCESS">
              A confirmation email has been sent to <span class="text-semibold">{{ profileStore.profile?.email }}</span>.
            </template>
            <template v-if="status === CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_FAILED">
              Unable to make a payment. Please try again.
            </template>
            <template v-if="status === CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_SOMETHING_WENT_WRONG">
              We are unable to process your order, please contact support for more information.
            </template>
          </p>
        </div>
        <div>
          <div
            v-if="status === CHECKOUT_PROCESS_STATUS_TEMPLATE.PAYMENT_SUCCESS"
            class="success-action"
          >
            <BaseButton
              class="btn-view-ticket"
              @click="$emit('onOpenTicketDetail')"
            >
              <template #leftIcon>
                <TicketIcon />
              </template>
              View ticket
            </BaseButton>
            <BaseButton
              variant="outlined"
              color="gray"
              @click="$emit('onAddCalendar')"
            >
              <template #leftIcon>
                <CalendarPlusIcon />
              </template>
              Add to calendar
            </BaseButton>
          </div>
        </div>
      </div>
    </template>
  </BaseSideDrawer>
</template>
<style scoped lang="scss">
.payment-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: spacings-get(6);
  padding: spacings-get(8) spacings-get(4);
  color: colors-get(gray, 600);

  div {
    width: 100%;
  }

  .btn-continue-checkout {
    margin: rem(25) 0;
  }

  .text-header {
    color: colors-get(gray, 900);
  }
}

.success-action {
  display: flex;
  flex-direction: column;
  gap: spacings-get(3);

  .btn {
    width: 100%;
  }
}
</style>